module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/leads/css/lead.component.css
// module id = ./src/app/modules/leads/css/lead.component.css
// module chunks = main